export const colsComponentYano = [
    { id: 1, header: "Id", accessor: "id", showExport: false, showTable: true, sort:true },
    { id: 3, header: "Name", accessor: "name", showExport: true, showTable: false, sort:true },
  ];

  export const colsComponent1 = [
    { id: 1, header: "Id", accessor: "id", showExport: false, showTable: true, sort:true },
    { id: 3, header: "Name", accessor: "name", showExport: true, showTable: false, sort:true },
    { id: 4, header: "Description", accessor: "description", showExport: false, showTable: true, sort:true }
  ];

  export const colsComponent7 = [
  { id: 1, header: "Id", accessor: "id", i18nKey: "admin.users.id", showTable: true, sort: true },
  { id: 2, header: "Name", accessor: "name", i18nKey: "admin.users.name", showTable: true, sort: true },
  //{ id: 3, header: "Description", accessor: "description", i18nKey: "admin.users.description", showTable: true, sort: false },
];

export const colsComponent = [
  { 
    id: 1, 
    header: "ID", 
    accessor: "id", 
    i18nKey: "general.groupconcern.table.id", 
    showTable: true, 
    sort: true,
    width: "1%" // <-- Cambiado a 1%
  },
  { 
    id: 2, 
    header: "Name", 
    accessor: "name", 
    i18nKey: "general.groupconcern.table.name", 
    showTable: true, 
    sort: true 
    // No ponemos width aquí para que esta columna use todo el espacio restante
  },
];